import * as React from "react";
const SvgTrashcanIconsDustbinLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, viewBox: "0 0 25 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#2175D9", fillRule: "evenodd", d: "M19.396 5a1 1 0 1 1 0 2v14a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V7a1 1 0 1 1 0-2h3V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2zm-12 15h10V7h-10zm4.138-11.375v10H9.688v-10zm3.693 0v10h-1.846v-10zM14.396 4v1h-4V4z" }));
export default SvgTrashcanIconsDustbinLine;
